import React, { Component } from 'react';
import {
    Container, Row, Col, Alert,
    Button,
    Input,
    Form, FormGroup, Label 
} from 'reactstrap';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';
import * as XLSX from "xlsx-js-style";
import 'bootstrap/dist/css/bootstrap.css';
import "react-table/react-table.css";
import "./Reports.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay, faRedo, faStar } from '@fortawesome/free-solid-svg-icons'
import { faStar as faStarOutline } from '@fortawesome/free-regular-svg-icons'
import PermissionWrapper from '../../auth/PermissionWrapper';
import Groupings from '../../components/Groupings/Groupings';
import CompanyContext from '../../auth/CompanyContext';
import { buildReportSubreportData, buildStatusPivot, getSalesActivityOverviewTotal } from './reportSubreports';

class SECReportsDetail extends Component {
    static contextType = CompanyContext;

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            reportIsLoading: true,
            report: [],
            columns: [],
            parameters: [],
            reportData: [],
            reportLookups: {},
            reportSettings: {},
            reportOutput: 'both',
            reportHasRun: false,
            parametersData: [],
            users: [],
            dateRange: '',
            autoRun: false,
            favorites: {
                sec: []
            },
            selectAllNone: false,
            selected: []
        };
    }

    changeSelectedAllNone = (e, items) => {
        if (e.target.checked) {
            this.setState({
                selected: [...items].map(item => item['SEC#'])
            })
        } else {
            this.setState({
                selected: []
            })
        }
    }

    changeSelected = (secID) => {
        this.setState(prevState => {
            let obj = { ...prevState }
            if (secID == null) {
                obj.selected = [];
            } else {
                let index = (obj?.selected ?? []).findIndex(i => i === secID);
                if (index === -1) {
                    obj.selected.push(secID);
                } else {
                    obj.selected.splice(index, 1);
                }
            }
            return obj;
        })
    }

    getFavorites = () => {
        this.props.loadFavorites(() => {
            this.setState({
                favorites: this.props.getFavorites()
            })
        })
    }

    componentDidMount = () => {
        this.getReportParameters();
        this.getUsers();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    parseColumns = (columns) => {
        columns.forEach(item => {
            switch (item.renderCell) {
                case "url":
                    item.Cell = row => row.value !== '' ? <Link target="_blank" to={{ pathname: row.value }}>{row.value}</Link> : <>{row.value}</>
                    break;
                case "sec":
                    item.Cell = row => row.value !== '' ? <Link to={{ pathname: '/demographics/' + row.value, state: { currentDate: this.props.current_date } }}>{row.value}</Link> : <>{row.value}</>
                    break;
                case "boolean":
                    item.Cell = row => row.value ? <>Yes</> : <>No</>
                    break;
                case "sec_blank":
                    item.Cell = row => row.value !== '' ? <Link target="_blank" to={{ pathname: '/demographics/' + row.value, state: { currentDate: this.props.current_date } }}>{row.value}</Link> : <>{row.value}</>
                    break;
                case "amount":
                    item.Cell = row => row.value !== '' && row.value != null ? <>${Intl.NumberFormat().format(row.value)}</> : <>{row.value}</>
                    break;
                case "date":
                    item.Cell = row => {
                        if (row.value === '' || row.value == null) return '';
                        // const custom_date = new Date(row.value);
                        // const custom_date_format = (custom_date.getMonth() + 1) + '/' + custom_date.getDate() + '/' + String(custom_date.getFullYear()).substr(-2);
                        return <>{parseInt(row.value.substr(5, 2))}/{parseInt(row.value.substr(8, 2))}/{parseInt(row.value.substr(2, 2))}</>
                    }
                    break;
                case "datetime":
                    item.Cell = row => row.value ? <>{new Date(row.value).toLocaleString()}</> : <></>
                    break;
                case "change_text":
                    item.Cell = row => <span style={{ whiteSpace: 'pre-line' }}>{row.value}</span>
                    break;
                case "company_detail":
                    item.Cell = row => {
                        const sec = row.original?.['Report SEC#'];
                        return sec ? <Link
                            onClick={() => localStorage.setItem('demographicsActiveTab', 1)}
                            to={{ pathname: '/demographics/' + sec, search: '?activeTab=1', state: { currentDate: this.props.current_date } }}
                        ><span style={{ whiteSpace: 'pre-line' }}>{row.value}</span></Link> : <>{row.value}</>
                    }
                    break;
                case "sales_opportunity_edit":
                    item.Cell = row => {
                        const sec = row.original?.['Report SEC#'];
                        const opportunityID = row.original?.['Report Opportunity ID'];
                        const type = row.original?.['Report Record Type'] === 'Sale' ? 'Sale' : 'Opportunity';
                        const activeTab = type === 'Sale' ? 4 : 3;
                        return sec && opportunityID ? <Link
                            onClick={() => localStorage.setItem('demographicsActiveTab', activeTab)}
                            to={{ pathname: '/demographics/' + sec, search: `?salesOpportunity=${encodeURIComponent(`${type}:${opportunityID}`)}`, state: { salesOpportunityID: opportunityID, salesOpportunityType: type } }}
                        ><span style={{ whiteSpace: 'pre-line' }}>{row.value}</span></Link> : <>{row.value}</>
                    }
                    break;
                default:
            }
        })
        return columns;
    }

    getValue = (param) => {
        if (param.type === 'bit') {
            return param.default === true;
        } else if (param.type === 'date' && param.days != null && !isNaN(param.days)) {
            return (new Date(new Date().getTime() + (60 * 60 * 24 * 1000 * param.days)).toISOString().substring(0, 10))
        } else if (param.type === 'date' && param.months != null && !isNaN(param.months)) {
            let date = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0);
            date.setDate(1);
            date.setMonth(date.getMonth() + param.months);
            return (date.toISOString().substring(0, 10))
        } else {
            return '';
        }
    }

    formatValue = (type, value) => {
        switch (type) {
            case "date":
                return parseInt(value.substr(5, 2)) + '/' + parseInt(value.substr(8, 2)) + '/' + value.substr(0, 4);
            case "bit":
                return value ? 'Yes' : 'No';
            default:
                return value;
        }
    }

    getReportParameters = () => {
        fetch('/api/reports/' + this.props.location.pathname.split('/').pop(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {

                const reportSettings = results.data.length === 1 && results.data[0].ReportSettings !== ''
                    ? JSON.parse(results.data[0].ReportSettings)
                    : [];

                this.setState((prevState, props) => {

                    let return_value = {
                        report: results.data.length === 1 ? results.data[0] : [],
                        columns: results.data.length === 1 && results.data[0].Columns !== '' ? this.parseColumns(JSON.parse(results.data[0].Columns)) : [],
                        parameters: results.data.length === 1 && results.data[0].Parameters !== '' ? JSON.parse(results.data[0].Parameters) : [],
                        reportSettings: reportSettings,
                        reportOutput: reportSettings?.outputOptions?.default || 'both',
                        reportHasRun: false,
                        parametersData: results.data.length === 1 && results.data[0].Parameters !== '' ? JSON.parse(results.data[0].Parameters).map(item => {
                            return { key: item.name, value: this.getValue(item), type: null }
                        }) : [],
                        isLoading: false,
                        autoRun: results.data.length === 1 ? results.data[0].AutoRun : false,
                        reportIsLoading: results.data.length === 1 ? (results.data[0].AutoRun ? true : false) : false,
                    };
                    return return_value;

                }, () => {
                    if (this.state.autoRun) this.getReportData();
                    if ((this.state?.columns ?? []).findIndex(column => column.accessor === 'SEC#') > -1
                        && this.state.report?.Function !== 'OpportunityProcessActivity') {
                        this.getFavorites();
                        let columns = [...this.state.columns];
                        columns.unshift(
                            {
                                Header: () => (
                                    <span>
                                        <input
                                            type="checkbox"
                                            name="selectAllNone"
                                            checked={this.state.selectAllNone || this.state.selected?.length === this.state.reportData?.length}
                                            onChange={(e) => this.changeSelectedAllNone(e, this.state.reportData)}
                                            className="text-center"
                                        />
                                    </span>
                                ),
                                accessor: 'SEC#',
                                filterable: false,
                                sortable: false,
                                width: 60,
                                Cell: row => <div onClick={() => this.changeSelected(row.row['SEC#'])} className="rt-resizable-header-content">
                                    <input
                                        type="checkbox"
                                        id={"group_" + row.row['SEC#']}

                                        checked={(this.state?.selected ?? []).findIndex(i => i === row.row['SEC#']) > -1}
                                    /></div>
                            },
                        )
                        columns.unshift(
                            {
                                Header: <FontAwesomeIcon icon={faStar} />,
                                accessor: 'Favorites',
                                filterable: false,
                                width: 60,
                                Cell: row => ((this.state?.favorites?.sec ?? []).findIndex(favorite => favorite.Favorite === row.row['SEC#']) > -1) ?
                                    <FontAwesomeIcon icon={faStar} className="favoriteIcon" onClick={() => this.props.removeFavorite('sec', row.row['SEC#'], this.getFavorites)} />
                                    : <FontAwesomeIcon icon={faStarOutline} className="favoriteIconDisabled" onClick={() => this.props.addFavorite('sec', row.row['SEC#'], this.getFavorites)} />
                            },
                        )
                        this.setState({
                            columns: columns
                        })
                    }
                });
            });
    }

    getReportData = () => {
        this.setState({
            reportIsLoading: true
        }, () => {
            fetch('/api/reports/' + this.props.location.pathname.split('/').pop(), {
                method: 'POST',
                body: JSON.stringify(this.state.parametersData),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.clientToken,
                    'X-Database': this.context.company
                }
            })
                .then(results => results.json())
                .then(results => {
                    let dateRange = '',
                        sd = (this.state?.parametersData ?? []).findIndex(item => item.key === "startDate") > -1 ? [...this.state.parametersData].filter(item => item.key === "startDate")[0].value : '',
                        ed = (this.state?.parametersData ?? []).findIndex(item => item.key === "endDate") > -1 ? [...this.state.parametersData].filter(item => item.key === "endDate")[0].value : '';
                    if (sd !== '' && ed !== '') {
                        sd = new Date(sd);
                        ed = new Date(ed);
                        dateRange = ' (' + (sd.getUTCMonth() + 1) + '/' + sd.getUTCDate() + '/' + String(sd.getUTCFullYear()).substr(-2) + ' - ' + (ed.getUTCMonth() + 1) + '/' + ed.getUTCDate() + '/' + String(ed.getUTCFullYear()).substr(-2) + ')';
                    } else
                        if (sd !== '' && ed === '') {
                            sd = new Date(sd);
                            dateRange = ' (' + (sd.getUTCMonth() + 1) + '/' + sd.getUTCDate() + '/' + String(sd.getUTCFullYear()).substr(-2) + ' - )';
                        } else
                            if (sd === '' && ed !== '') {
                                ed = new Date(ed);
                                dateRange = ' ( - ' + (ed.getUTCMonth() + 1) + '/' + ed.getUTCDate() + '/' + String(ed.getUTCFullYear()).substr(-2) + ')';
                            }
                    this.setState((prevState, props) => {

                        let return_value = {
                            dateRange: dateRange,
                            reportData: results.data,
                            reportLookups: results.lookups || {},
                            reportHasRun: true,
                            reportIsLoading: false
                        };
                        return return_value;

                    });
                });
        });
    }

    onChange = (e, index, type) => {
        e.persist();
        let sel = this.state.parametersData;
        sel[index] = {
            key: e.target.name,
            value: e.target.type === 'checkbox' ? e.target.checked : e.target.value,
            type: type
        };
        this.setState({
            parametersData: sel
        })
    }

    reset = () => {
        this.setState({
            parametersData: [...this.state.parameters].map(item => {
                return { key: item.name, value: this.getValue(item), type: null }
            }),
            reportOutput: this.state.reportSettings?.outputOptions?.default || 'both'
        }, () => this.getReportData());
    }

    getSubreports = () => Array.isArray(this.state.reportSettings?.subreports)
        ? this.state.reportSettings.subreports
        : [];

    getSubreportView = subreport => {
        if (subreport.type === 'statusPivot') {
            const listing = this.getSubreports().find(item => item.key === subreport.sourceKey);
            if (!listing) return { columns: [], data: [] };
            const listingView = this.getSubreportView(listing);
            return buildStatusPivot(listingView.data,
                this.state.reportLookups?.[listing.availableValuesDataKey] || listing.availableValues || [],
                listing);
        }
        return {
            columns: this.parseColumns([...(subreport.columns || [])]),
            data: buildReportSubreportData(this.state.reportData, {
                ...subreport,
                availableValues: this.state.reportLookups?.[subreport.availableValuesDataKey] || subreport.availableValues || []
            })
        };
    };

    showsDetail = () => !this.state.reportSettings?.outputOptions
        || this.state.reportOutput === 'detail'
        || this.state.reportOutput === 'both'
        || this.state.reportOutput === 'all';

    showsSubreport = subreport => this.state.reportOutput === 'all'
        || this.state.reportOutput === 'both'
        || this.state.reportOutput === (subreport.outputOption || 'totals');

    onOutputChange = e => this.setState({ reportOutput: e.target.value });

    renderSubreports = subreports => subreports.map(subreport => {
        const { data, columns } = this.getSubreportView(subreport);
        return <Row key={subreport.key || subreport.title} className="mb-4">
            <Col md={12}>
                <h3>{subreport.title || 'Totals'}</h3>
                {subreport.type === 'statusPivot'
                    ? <div className="table-responsive"><table className="table table-striped table-bordered status-pivot-table">
                        <thead><tr>{columns.map(column => <th key={column.accessor} scope="col">{column.Header}</th>)}</tr></thead>
                        <tbody>{data.map((row, rowIndex) => <tr key={rowIndex} className={row.isTotalsRow ? 'status-pivot-totals-row' : undefined}>
                            {columns.map((column, index) => index === 0
                                ? <th key={column.accessor} scope="row">{row[column.accessor]}</th>
                                : <td key={column.accessor}>{this.getExportValue(column, row[column.accessor])}</td>)}
                        </tr>)}</tbody>
                    </table></div>
                    : <ReactTable
                        data={data}
                        columns={columns}
                        pageSize={data.length}
                        showPagination={false}
                        defaultSorted={subreport.sort || []}
                        className="-striped -highlight"
                    />}
            </Col>
        </Row>
    });

    getExportValue = (column, value) => {
        if (value == null || value === '') return '';
        switch (column.renderCell) {
            case 'zero_as_dash':
                return value === 0 ? '-' : value;
            case 'datetime':
                return new Date(value).toLocaleString();
            case 'date':
                return parseInt(value.substr(5, 2)) + '/' + parseInt(value.substr(8, 2)) + '/' + value.substr(0, 4);
            case 'amount':
                return '$' + Intl.NumberFormat().format(value);
            case 'boolean':
                return value ? 'Yes' : 'No';
            case 'change_text':
                return String(value).replace(/\r\n?/g, '\n');
            default:
                return value;
        }
    }

    getExportLink = (column, row) => {
        const sec = row?.['Report SEC#'];
        if (!sec) return null;
        const companyURL = `${window.location.origin}/demographics/${encodeURIComponent(sec)}?activeTab=1`;
        if (column.renderCell === 'company_detail') return companyURL;
        if (column.renderCell !== 'sales_opportunity_edit' || !row?.['Report Opportunity ID']) return null;
        const type = row?.['Report Record Type'] === 'Sale' ? 'Sale' : 'Opportunity';
        return `${window.location.origin}/demographics/${encodeURIComponent(sec)}?salesOpportunity=${encodeURIComponent(`${type}:${row['Report Opportunity ID']}`)}`;
    }

    handleExport = () => {
        const exportColumns = [...this.state.columns].filter(column =>
            typeof column.Header === 'string'
            && typeof column.accessor === 'string'
            && column.accessor !== 'Favorites'
        );
        const outputSettings = this.state.reportSettings?.outputOptions;
        const subreportExports = this.getSubreports().filter(this.showsSubreport).map(subreport => {
            const view = this.getSubreportView(subreport);
            return {
                settings: subreport,
                columns: view.columns.filter(column =>
                    typeof column.Header === 'string' && typeof column.accessor === 'string'
                ),
                data: view.data
            };
        });
        const reportName = String(this.state.report?.Name || '').trim();
        let datagrid = reportName ? [[reportName]] : [];
        datagrid.push(...[...this.state.parametersData]
            .filter(item => item.value != null && item.value !== '')
            .map(item => {
                let index = (this.state?.parametersData ?? []).findIndex(i => i.key === item.key)
                return [this.state.parameters[index].label, this.formatValue(this.state.parameters[index].type, item.value)]
            }));
        if (outputSettings) {
            const selectedOutput = (outputSettings.options || []).find(option => option.value === this.state.reportOutput);
            datagrid.push([outputSettings.label || 'Report Options', selectedOutput?.label || this.state.reportOutput]);
        }

        const sectionHeaderRows = [];
        const tableHeaderRows = [];
        const appendSubreportExports = subreports => {
            subreports.forEach(subreport => {
                datagrid.push([]);
                sectionHeaderRows.push(datagrid.length);
                datagrid.push([subreport.settings.title || 'Totals']);
                tableHeaderRows.push(datagrid.length);
                datagrid.push(subreport.columns.map(column => column.Header));
                subreport.data.forEach(row => {
                    datagrid.push(subreport.columns.map(column => this.getExportValue(column, row[column.accessor])));
                });
            });
        };
        appendSubreportExports(subreportExports.filter(subreport => subreport.settings.position !== 'afterDetail'));

        let detailHeaderRow = null;
        if (this.showsDetail()) {
            datagrid.push([]);
            if (outputSettings) {
                sectionHeaderRows.push(datagrid.length);
                datagrid.push([this.state.reportSettings?.detail?.title || 'Detail']);
            }
            detailHeaderRow = datagrid.length;
            tableHeaderRows.push(detailHeaderRow);
            datagrid.push(exportColumns.map(column => column.Header));
            this.state.reportData.forEach(row => {
                datagrid.push(exportColumns.map(column => this.getExportValue(column, row[column.accessor])));
            });
            if (this.state.report?.Function === 'SalesActivityOverview') {
                const totalsRow = { Description: 'TOTALS', Count: getSalesActivityOverviewTotal(this.state.reportData) };
                datagrid.push(exportColumns.map(column => this.getExportValue(column, totalsRow[column.accessor])));
            }
        }
        appendSubreportExports(subreportExports.filter(subreport => subreport.settings.position === 'afterDetail'));

        let wb = XLSX.utils.book_new();
        let ws = XLSX.utils.aoa_to_sheet(datagrid);
        const allColumnSets = [exportColumns, ...subreportExports.map(subreport => subreport.columns)];
        const exportColumnCount = Math.max(1, ...allColumnSets.map(columns => columns.length));
        ws['!cols'] = Array.from({ length: exportColumnCount }, (_, index) => ({
            wch: Math.max(12, ...allColumnSets.map(columns => Math.round((columns[index]?.width || 0) / 7)))
        }));
        ws['!rows'] = datagrid.map(row => {
            const lineCount = row.reduce((maximum, value) => Math.max(maximum, String(value ?? '').split('\n').length), 1);
            return lineCount > 1 ? { hpt: lineCount * 15 } : {};
        });
        if (ws['!ref']) {
            const range = XLSX.utils.decode_range(ws['!ref']);
            for (let row = range.s.r; row <= range.e.r; row++) {
                for (let col = range.s.c; col <= range.e.c; col++) {
                    const cell = ws[XLSX.utils.encode_cell({ r: row, c: col })];
                    if (cell) cell.s = { alignment: { vertical: 'top', wrapText: true } };
                }
            }
        }
        if (reportName && ws.A1) {
            ws.A1.s = {
                ...ws.A1.s,
                font: { bold: true, sz: 14 }
            };
        }
        sectionHeaderRows.forEach(row => {
            const cell = ws[XLSX.utils.encode_cell({ r: row, c: 0 })];
            if (cell) cell.s = { ...cell.s, font: { bold: true, sz: 12 } };
        });
        tableHeaderRows.forEach(row => {
            for (let column = 0; column < exportColumnCount; column++) {
                const cell = ws[XLSX.utils.encode_cell({ r: row, c: column })];
                if (cell) cell.s = { ...cell.s, font: { bold: true } };
            }
        });
        if (detailHeaderRow != null) {
            this.state.reportData.forEach((row, rowIndex) => {
                exportColumns.forEach((column, columnIndex) => {
                    const link = this.getExportLink(column, row);
                    const cell = ws[XLSX.utils.encode_cell({ r: detailHeaderRow + rowIndex + 1, c: columnIndex })];
                    if (link && cell) cell.l = { Target: link };
                });
            });
        }
        XLSX.utils.book_append_sheet(wb, ws, 'Export');
        XLSX.writeFile(wb, this.state.report.Name + this.state.dateRange + '.xlsx', { cellStyles: true });
    }

    filterCaseInsensitive = (filter, row) => {
        const id = filter.pivotId || filter.id;
        return (
            row[id] != null ?
                String(row[id]).toLowerCase().indexOf(String(filter.value).toLowerCase()) > -1
                :
                false
        );
    }

    getUsers = () => {
        // console.log('ReportsDetail.js/getUsers()');
        fetch('/api/users/', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                this.setState((prevState, props) => {
                    let return_value = {
                        users: results.data,
                    };
                    return return_value;
                });
            });
    }

    getFormField = (param, index) => {
        switch (param.type) {
            case "user":
                return (
                    <Input type="select" name={param.name} onChange={(e) => this.onChange(e, index, param.type)} value={this.state.parametersData[index]['value']} >
                        <option value="">{param.allLabel || 'User'}</option>
                        {this.state.users.filter(user => user.Active).map(user => (
                            <option key={user.Auth0} value={user.Auth0}>{user['Full Name']}</option>
                        ))}
                    </Input>
                )
            case "date":
                return (
                    <Input type="date"
                        name={param.name}
                        onChange={(e) => this.onChange(e, index, param.type)}
                        value={this.state.parametersData[index]['value']}
                    />
                )
            case "bit":
                return (
                    <Label check for={param.name}>
                        <Input
                            id={param.name}
                            type="checkbox"
                            name={param.name}
                            checked={this.state.parametersData[index]['value'] === true}
                            onChange={(e) => this.onChange(e, index, param.type)}
                        />
                        {param.label}
                    </Label>
                )
            default:
                return (
                    <Input type={param.type} name={param.name} onChange={(e) => this.onChange(e, index, param.type)} value={this.state.parametersData[index]['value']} />
                )
        }
    }

    render() {
        if (!this.state.isLoading) {
            const outputSettings = this.state.reportSettings?.outputOptions;
            const subreports = this.getSubreports();
            const isSalesActivityOverview = this.state.report?.Function === 'SalesActivityOverview';
            const detailColumns = isSalesActivityOverview
                ? this.state.columns.map(column => ({
                    ...column,
                    Footer: column.accessor === 'Description' ? 'TOTALS'
                        : column.accessor === 'Count' ? ({ data }) => getSalesActivityOverviewTotal(data) : undefined
                }))
                : this.state.columns;
            const indexedParameters = this.state.parameters.map((parameter, index) => ({ parameter, index }));
            const standardParameters = indexedParameters.filter(({ parameter }) => parameter.position !== 'afterReportOptions');
            const trailingParameters = indexedParameters.filter(({ parameter }) => parameter.position === 'afterReportOptions');
            const renderParameter = ({ parameter, index }) => (
                <FormGroup key={parameter.name} className="mr-2">
                    {parameter.type !== 'bit' && <Label for={parameter.name}>{parameter.label}</Label>}
                    {this.getFormField(parameter, index)}
                </FormGroup>
            );
            return (
                <PermissionWrapper {...this.props} allowedPermission="Reports">
                    <Container fluid={true}>
                        <Row>
                            <div style={{ width: this.state.columns.reduce((prev, cur) => prev + (cur.width != null ? cur.width : 0), 0) }}></div>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <h2>{this.state.report.Name} ({this.state.reportData != null ? this.state.reportData.length : '0'})</h2>
                                {this.state.dateRange !== '' ? <p><strong>{this.state.dateRange}</strong></p> : <></>}
                                <p>{this.state.report.Description}</p>
                                <p>
                                    <Link className="btn btn-secondary mx-1" to={{ pathname: '/reports/' }}>Return to Reports</Link>
                                    <Button color="primary" className="mx-1" onClick={this.handleExport}>Export XLSX</Button>
                                </p>
                            </Col>
                            <Col md={4}>
                                <Form >
                                    {standardParameters.map(renderParameter)}
                                    {outputSettings && <FormGroup className="mr-2">
                                        <Label className="d-block">{outputSettings.label || 'Report Options'}</Label>
                                        {(outputSettings.options || []).map(option => (
                                            <FormGroup check inline key={option.value}>
                                                <Input
                                                    type="radio"
                                                    id={`report-output-${option.value}`}
                                                    name="reportOutput"
                                                    value={option.value}
                                                    checked={this.state.reportOutput === option.value}
                                                    onChange={this.onOutputChange}
                                                />
                                                <Label check for={`report-output-${option.value}`}>{option.label}</Label>
                                            </FormGroup>
                                        ))}
                                    </FormGroup>}
                                    {trailingParameters.map(renderParameter)}
                                </Form>
                            </Col>
                            <Col md={2}>
                                <Button disabled={this.state.reportIsLoading} color="success" onClick={this.getReportData} className="m-1"><FontAwesomeIcon icon={faPlay} /></Button>
                                <Button disabled={this.state.reportIsLoading} color="secondary" onClick={this.reset} className="m-1"><FontAwesomeIcon icon={faRedo} /></Button>
                                {this.state.selected.length > 0 && <Row className='mt-4'>
                                    <Groupings
                                        {...this.props}
                                        favoriteCallback={this.getFavorites}
                                        selected={this.state.selected}
                                        changeSelected={this.changeSelected}
                                    />
                                </Row>}
                            </Col>
                        </Row>
                        {!this.state.reportIsLoading && this.state.reportHasRun
                            && this.renderSubreports(subreports.filter(subreport => subreport.position !== 'afterDetail' && this.showsSubreport(subreport)))}
                        {!this.state.reportIsLoading && this.state.reportHasRun && this.showsDetail() && <Row>
                            <Col md={12}>
                                {outputSettings && <h3>{this.state.reportSettings?.detail?.title || 'Detail'}</h3>}
                                <ReactTable
                                    data={this.state.reportData}
                                    columns={detailColumns}
                                    getTfootProps={() => ({ className: isSalesActivityOverview ? 'sales-activity-overview-totals' : undefined })}
                                    pageSize={this.state.reportData != null ? this.state.reportData.length : 0}
                                    filterable
                                    defaultFilterMethod={(filter, row) => this.filterCaseInsensitive(filter, row)}
                                    showPagination={false}
                                    defaultSorted={(this.state.reportSettings != null && JSON.stringify(this.state.reportSettings) !== '[]' && this.state.reportSettings.sort != null) ? this.state.reportSettings.sort : []}
                                />
                            </Col>
                        </Row>}
                        {!this.state.reportIsLoading && this.state.reportHasRun
                            && this.renderSubreports(subreports.filter(subreport => subreport.position === 'afterDetail' && this.showsSubreport(subreport)))}
                        {this.state.reportIsLoading && <Row><Col md={12}><Alert color="info">
                            Loading report - please be patient, this may take a minute...
                        </Alert></Col></Row>}
                    </Container>
                </PermissionWrapper>
            );
        } else {
            return (
                <Row>
                    <Col md={12} className='text-center'>
                        <h1>Loading...</h1>
                    </Col>
                </Row>
            )
        }
    }
}

export default SECReportsDetail;
